import { create } from 'zustand';

import { ISnapStore } from './types';

export const snapStoreValues: Readonly<ISnapStore> = {
  imgURL: '',
  status: null,
  lineItems: [],
  lineItemOptions: [],
  activeTabKey: '1',
  claimDetails: '',
  claimReferenceCode: '',
  fraudSuspicionReason: '',
  escalateDetails: '',
  eligibleOfferOptions: [],
  eligibleProductOptions: [],
  processingByOpsUserId: 0,
  processingByOpsUserRole: '',
  processingByOpsUserEmail: '',
  processingByOpsUserIdStartedAt: '',
  refetchSnapData: false,
  refetchEligibleProductsData: false,
  eligibleProductIdentities: [],
  productIdentitiesOptions: [],
  snapBooleanStatuses: {
    isEscalated: false,
    isProcessing: false,
    isMarkedAsDone: false,
    isNextSnapVisible: false,
    isNextSnapAllowed: false,
    isReprocessingAllowed: false,
    isRequiresTroubleshooting: false,
    isLineItemsCreationAllowed: true,
    isCompleteProcessingAllowed: false,
    isFraudSuspicious: false,
    isCollectorFraudster: false,
    hasConflictedMatches: false,
    hasDirtyTransactions: false,
    hasFlippedDayAndYear: false,
    canHaveOfferMatches: false,
  },
  ocrScores: {
    totalScore: 0,
    totalOcrScore: 0,
    totalTaxScore: 0,
    totalTaxOcrScore: 0,
    subtotalScore: 0,
    subtotalOcrScore: 0,
    receiptTimestampScore: 0,
    receiptTimestampOcrScore: 0,
  },
  ocrFormValues: {
    total: 0,
    subtotal: 0,
    totalTax: 0,
    retailerId: 0,
    receiptTimestamp: null,
  },
  overviewFormValues: {
    locale: '',
    platform: '',
    collectorId: '',
    submittedDate: null,
    duplicateOf: 0,
    duplicates: [],
    externalId: 0,
    referenceCode: '',
    collectorRegion: '',
  },
};

export const snapStore = create<ISnapStore>()(() => snapStoreValues);
